module.exports = __webpack_public_path__ + "img/stock10.0c2b9988.png";